import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
import { getEnvVar } from '@/assets/js/helpers'

Vue.use(VueRouter)

const tenantData = require(`@/assets/${process.env.VUE_APP_TENANT}.json`)
const isSingleClub = tenantData.isSingleClub
const prefixPathClub = isSingleClub ? '' : '/club/:id'

let routes
const routeClubChildren = [
  {
    name: 'Club',
    path: '',
    component: () => import('../views/Club/Overview.vue')
  },
  {
    name: 'ClubMembers',
    path: 'members',
    component: () => import('../views/Club/Members.vue')
  },
  {
    name: 'ClubTrainings',
    path: 'trainings',
    component: () => import('../views/Club/Trainings.vue')
  },
  {
    name: 'ClubChamps',
    path: 'champs',
    component: () => import('../views/Club/Champs.vue')
  }
]

const routeClubCommon = [
  {
    name: 'ManageClub',
    path: `${prefixPathClub}/manage`,
    component: () => import('../views/ManageClub.vue'),
    redirect: `${prefixPathClub}/manage/settings/`,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'ManageSettings',
        path: 'settings',
        component: () => import('../views/ManageClub/Settings.vue')
      },
      {
        name: 'ManageMembers',
        path: 'members',
        component: () => import('../views/ManageClub/Members.vue')
      },
      {
        name: 'ManageRequests',
        path: 'requests',
        component: () => import('../views/ManageClub/Requests.vue')
      },
      {
        name: 'ManageChamps',
        path: 'champs',
        component: () => import('../views/ManageClub/Champs.vue')
      }
    ]
  },
  {
    path: `${prefixPathClub}/create-champ/:champ?`,
    name: 'CreateChamp',
    component: () => import('../views/CreateChamp.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: `${prefixPathClub}/manage-champ/:champId`,
    name: 'EditChamp',
    component: () => import('../views/ManageChamp.vue'),
    redirect: `${prefixPathClub}/manage-champ/:champId/settings`,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'EditChampInfo',
        path: 'settings',
        component: () => import('../views/ManageChamp/Info.vue')
      },
      {
        name: 'EditChampNominations',
        path: 'nominations',
        component: () => import('../views/ManageChamp/Nominations.vue')
      },
      {
        name: 'EditChampStages',
        path: 'stages',
        component: () => import('../views/ManageChamp/Stages.vue')
      }
    ]
  }
]

if (isSingleClub) {
  routes = [
    {
      path: '*',
      component: () => import('../views/Club.vue')
    },
    {
      path: '/',
      component: () => import('../views/Club.vue'),
      props: true,
      children: routeClubChildren
    },
    ...routeClubCommon
  ]
} else {
  routes = [
    {
      path: '*',
      component: Home
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/create',
      name: 'CreateClub',
      component: () => import('../views/CreateClub.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/club/:id',
      component: () => import('../views/Club.vue'),
      props: true,
      children: routeClubChildren
    },
    ...routeClubCommon
  ]
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: 'exact-active',
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      const header = document.querySelector('.header')
      const offset = header ? header.offsetHeight : 0
      return {
        selector: to.hash,
        offset: { x: 0, y: offset }
      }
    }
    if (to.name === from.name) {
      return savedPosition
    }
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAuthorized =
      store.state.user.isAuthorized ||
      typeof to.query.fromLogin !== 'undefined'
    if (!isAuthorized) {
      window.location.href = `${getEnvVar('VUE_APP_RR_URL')}user/login?returnUrl=${window.location.origin}${to.path}?fromLogin`
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
